// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-B943B10E-9BEA-440F-9BD9-07792DBE094D {\n  height: inherit;\n}\n", "",{"version":3,"sources":["webpack://src/uicomponents/components/dragDropContainer/dragDropContainer.less"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ","sourcesContent":["#V-B943B10E-9BEA-440F-9BD9-07792DBE094D{\n    height: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
